// project imports
import { ApplicableAction } from 'utils/constants';

// ==============================|| CONTEXT ACTIONS TYPES  ||============================== //

export interface ContextAction {
  code: CaCodeType;
  applicability: ApplicableAction;
  reasonCode: string;
}

export interface ResourceContextAction {
  resourceEntity?: string;
  identificator?: string;
  contextActions: ContextAction[];
}

export type CaCodeType =
  | ActivityLogCaType
  | EaiCaType
  | DispatcherCaType
  | ReportingCaType;

export type ActivityLogCaType = ActivityLogCA;

export enum ActivityLogCA {
  CA_LIST_ACTIVITY_LOG = 'CA_LIST_ACTIVITY_LOG'
}

export type EaiCaType =
  | EaiSubjectsCA
  | EaiUsersCA
  | EaiDeliveryPointsCA
  | EaiBalanceGroupCA
  | EaiDevicesCA
  | EaiDeliveryContractsCA
  | EaiAccessPageCA;

export type GetContextActionsRequestBody = {
  resourceEntity: string;
  identificators: (string | bigint | number)[];
  contextActions: CaCodeType[];
}[];

export enum EaiSubjectsCA {
  CA_EAI_LIST_PARTY = 'CA_EAI_LIST_PARTY',
  CA_EAI_GET_PARTY = 'CA_EAI_GET_PARTY',
  CA_EAI_CREATE_PARTY = 'CA_EAI_CREATE_PARTY',
  CA_EAI_EDIT_PARTY = 'CA_EAI_EDIT_PARTY',
  CA_EAI_DELETE_PARTY = 'CA_EAI_DELETE_PARTY',
  CA_EAI_GET_MEMBER_ACCOUNT = 'CA_EAI_GET_MEMBER_ACCOUNT',
  CA_EAI_CREATE_MEMBER_ACCOUNT = 'CA_EAI_CREATE_MEMBER_ACCOUNT',
  CA_EAI_EDIT_MEMBER_ACCOUNT = 'CA_EAI_EDIT_MEMBER_ACCOUNT',
  CA_EAI_CHECK_PARTY_NAME = 'CA_EAI_CHECK_PARTY_NAME',
  CA_EAI_CHECK_PARTY_IDENTIFIER = 'CA_EAI_CHECK_PARTY_IDENTIFIER',
  CA_EAI_CHECK_MARKET_PARTICIPANT_EIC = 'CA_EAI_CHECK_MARKET_PARTICIPANT_EIC',
  CA_EAI_GET_MARKET_PARTICIPANT = 'CA_EAI_GET_MARKET_PARTICIPANT',
  CA_EAI_EDIT_MARKET_PARTICIPANT = 'CA_EAI_EDIT_MARKET_PARTICIPANT',
  CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL = 'CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL',
  CA_EAI_DISABLE_MEMBER_ACCOUNT = 'CA_EAI_DISABLE_MEMBER_ACCOUNT',
  CA_EAI_RESTORE_MEMBER_ACCOUNT = 'CA_EAI_RESTORE_MEMBER_ACCOUNT',
  CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT = 'CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT',
  CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT = 'CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT',
  CA_EAI_LIST_MEMBER_ACCOUNT = 'CA_EAI_LIST_MEMBER_ACCOUNT',
  CA_EAI_LIST_USER_ROLES_FOR_ASSIGNMENT = 'CA_EAI_LIST_USER_ROLES_FOR_ASSIGNMENT',
  CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS = 'CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS',
  CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS = 'CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS',
  CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS = 'CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS',
  CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS = 'CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS',
  CA_EAI_UPLOAD_DAMAS_CREDENTIALS = 'CA_EAI_UPLOAD_DAMAS_CREDENTIALS',
  CA_EAI_LIST_PARTY_DELETED = 'CA_EAI_LIST_PARTY_DELETED'
}

export enum EaiUsersCA {
  CA_EAI_LIST_USER = 'CA_EAI_LIST_USER',
  CA_EAI_GET_USER = 'CA_EAI_GET_USER',
  CA_EAI_CREATE_USER = 'CA_EAI_CREATE_USER',
  CA_EAI_CHECK_USER_EMAIL = 'CA_EAI_CHECK_USER_EMAIL',
  CA_EAI_EDIT_USER = 'CA_EAI_EDIT_USER',
  CA_EAI_BLOCK_USER = 'CA_EAI_BLOCK_USER',
  CA_EAI_UNBLOCK_USER = 'CA_EAI_UNBLOCK_USER',
  CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT = 'CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT',
  CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT = 'CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT',
  CA_EAI_USER_ASSIGN_ROLE = 'CA_EAI_USER_ASSIGN_ROLE',
  CA_EAI_USER_UNASSIGN_ROLE = 'CA_EAI_USER_UNASSIGN_ROLE',
  CA_EAI_RESET_USER_PASSWORD = 'CA_EAI_RESET_USER_PASSWORD',
  CA_EAI_DELETE_USER = 'CA_EAI_DELETE_USER',
  CA_EAI_EDIT_USER_USERNAME = 'CA_EAI_EDIT_USER_USERNAME'
}

export enum EaiDeliveryPointsCA {
  CA_EAI_LIST_DELIVERY_POINT = 'CA_EAI_LIST_DELIVERY_POINT',
  CA_EAI_GET_DELIVERY_POINT = 'CA_EAI_GET_DELIVERY_POINT',
  CA_EAI_EDIT_DELIVERY_POINT = 'CA_EAI_EDIT_DELIVERY_POINT',
  CA_EAI_EDIT_DELIVERY_POINT_CHARACTERISTIC = 'CA_EAI_EDIT_DELIVERY_POINT_CHARACTERISTIC',
  CA_EAI_LIST_DELIVERY_POINT_GDS = 'CA_EAI_LIST_DELIVERY_POINT_GDS',
  CA_EAI_EDIT_DELIVERY_POINT_GDS = 'CA_EAI_EDIT_DELIVERY_POINT_GDS',
  CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT = 'CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT',
  CA_EAI_CREATE_DELIVERY_POINT = 'CA_EAI_CREATE_DELIVERY_POINT'
}

export enum EaiBalanceGroupCA {
  CA_EAI_GET_BALANCE_GROUP = 'CA_EAI_GET_BALANCE_GROUP',
  CA_EAI_EDIT_BALANCE_GROUP = 'CA_EAI_EDIT_BALANCE_GROUP',
  CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS = 'CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS',
  CA_EAI_LIST_BALANCE_GROUP = 'CA_EAI_LIST_BALANCE_GROUP',
  CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC = 'CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC',
  CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC_VAL_OPTIMIZED_PERIOD_NUMBER = 'CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC_VAL_OPTIMIZED_PERIOD_NUMBER'
}

export enum EaiDevicesCA {
  CA_EAI_LIST_DEVICE = 'CA_EAI_LIST_DEVICE',
  CA_EAI_GET_DEVICE = 'CA_EAI_GET_DEVICE',
  CA_EAI_EDIT_DEVICE = 'CA_EAI_EDIT_DEVICE',
  CA_EAI_REMOVE_DEVICE = 'CA_EAI_REMOVE_DEVICE',
  CA_EAI_CHANGE_DEVICE_GDS = 'CA_EAI_CHANGE_DEVICE_GDS',
  CA_EAI_EDIT_DEVICE_CHARACTERISTICS = 'CA_EAI_EDIT_DEVICE_CHARACTERISTICS',
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP = 'CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP',
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION = 'CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION',
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION_DELIVERY_POINT = 'CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION_DELIVERY_POINT',
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION_BALANCING_GROUP = 'CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_PRODUCTION_OPTIMIZATION_BALANCING_GROUP',
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_RESERVED_CAPACITY_GUARDING = 'CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP_RESERVED_CAPACITY_GUARDING',
  CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP = 'CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP',
  CA_EAI_CREATE_DEVICE = 'CA_EAI_CREATE_DEVICE'
}

export enum EaiDeliveryContractsCA {
  CA_EAI_LIST_DELIVERY_CONTRACT = 'CA_EAI_LIST_DELIVERY_CONTRACT',
  CA_EAI_GET_DELIVERY_CONTRACT = 'CA_EAI_GET_DELIVERY_CONTRACT',
  CA_EAI_EDIT_DELIVERY_CONTRACT = 'CA_EAI_EDIT_DELIVERY_CONTRACT',
  CA_EAI_CREATE_DELIVERY_CONTRACT = 'CA_EAI_CREATE_DELIVERY_CONTRACT'
}

export enum EaiAccessPageCA {
  CA_EAI_ACCESS_USER_PAGE = 'CA_EAI_ACCESS_USER_PAGE',
  CA_EAI_ACCESS_PARTY_PAGE = 'CA_EAI_ACCESS_PARTY_PAGE',
  CA_EAI_ACCESS_BALANCING_GROUP_PAGE = 'CA_EAI_ACCESS_BALANCING_GROUP_PAGE',
  CA_EAI_ACCESS_DELIVERY_POINT_PAGE = 'CA_EAI_ACCESS_DELIVERY_POINT_PAGE',
  CA_EAI_ACCESS_DEVICE_PAGE = 'CA_EAI_ACCESS_DEVICE_PAGE',
  CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE = 'CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE'
}

export type DispatcherCaType =
  | DispatcherRkCA
  | DispatcherProductionPlanningCA
  | DispatcherOperationCalendarCA
  | DispatcherAccessPageCA
  | DispatcherAlarmsCA;

export enum DispatcherAlarmsCA {
  CA_LIST_ALARM = 'CA_LIST_ALARM',
  CA_CANCEL_ALARM = 'CA_CANCEL_ALARM',
  CA_RESOLVE_ALARM = 'CA_RESOLVE_ALARM'
}

export enum DispatcherRkCA {
  CA_DISP_LIST_RESERVED_CAPACITY_GUARDING_ACTION = 'CA_DISP_LIST_RESERVED_CAPACITY_GUARDING_ACTION',
  CA_DISP_GET_RESERVED_CAPACITY_GUARDING_ACTION = 'CA_DISP_GET_RESERVED_CAPACITY_GUARDING_ACTION',
  CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION = 'CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION',
  CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION = 'CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION',
  CA_DISP_LIST_RESERVED_CAPACITY_GUARDING_ACTIVITY_LOG = 'CA_DISP_LIST_RESERVED_CAPACITY_GUARDING_ACTIVITY_LOG'
}

export enum DispatcherOperationCalendarCA {
  CA_DISP_LIST_OPERATION_EVENT = 'CA_DISP_LIST_OPERATION_EVENT ',
  CA_DISP_LIST_OPERATION_EVENT_ACTIVITY_LOG = 'CA_DISP_LIST_OPERATION_EVENT_ACTIVITY_LOG',
  CA_DISP_CREATE_OPERATION_EVENT = 'CA_DISP_CREATE_OPERATION_EVENT',
  CA_DISP_GET_OPERATION_EVENT = 'CA_DISP_GET_OPERATION_EVENT',
  CA_DISP_EDIT_OPERATION_EVENT = 'CA_DISP_EDIT_OPERATION_EVENT',
  CA_DISP_CANCEL_OPERATION_EVENT = 'CA_DISP_CANCEL_OPERATION_EVENT',
  CA_DISP_DELETE_OPERATION_EVENT = 'CA_DISP_DELETE_OPERATION_EVENT',
  CA_DISP_OPERATION_EVENT_NO_DATE_SETTING_RESTRICTIONS = 'CA_DISP_OPERATION_EVENT_NO_DATE_SETTING_RESTRICTIONS'
}

export enum DispatcherProductionPlanningCA {
  CA_DISP_GET_DEVICE_PRODUCTION_PLAN = 'CA_DISP_GET_DEVICE_PRODUCTION_PLAN',
  CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN = 'CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN',
  CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN = 'CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN',
  CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN = 'CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN',
  CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN = 'CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN',
  CA_DISP_COPY_DEVICE_PRODUCTION_PLAN = 'CA_DISP_COPY_DEVICE_PRODUCTION_PLAN',
  CA_DISP_CREATE_DAILY_DIAGRAM = 'CA_DISP_CREATE_DAILY_DIAGRAM',
  CA_DISP_EDIT_DAILY_DIAGRAM = 'CA_DISP_EDIT_DAILY_DIAGRAM',
  CA_DISP_LIST_DAILY_DIAGRAM_ACTIVITY_LOG = 'CA_DISP_LIST_DAILY_DIAGRAM_ACTIVITY_LOG',
  CA_DISP_LIST_PRODUCTION_PLAN_ACTIVITY_LOG = 'CA_DISP_LIST_PRODUCTION_PLAN_ACTIVITY_LOG',
  CA_DISP_GET_DAILY_DIAGRAM = 'CA_DISP_GET_DAILY_DIAGRAM',
  CA_DISP_LIST_DAILY_DIAGRAM = 'CA_DISP_LIST_DAILY_DIAGRAM',
  CA_DISP_VALIDATE_DAILY_DIAGRAM = 'CA_DISP_VALIDATE_DAILY_DIAGRAM',
  CA_DISP_ACCEPT_DAILY_DIAGRAM = 'CA_DISP_ACCEPT_DAILY_DIAGRAM',
  CA_DISP_EXPORT_DAILY_DIAGRAM = 'CA_DISP_EXPORT_DAILY_DIAGRAM',
  CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION = 'CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION'
}

export enum DispatcherAccessPageCA {
  CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE = 'CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE',
  CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE = 'CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE',
  CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE = 'CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE',
  CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE = 'CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE',
  CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE = 'CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE',
  CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE = 'CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE',
  CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE = 'CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE',
  CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE = 'CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE',
  CA_DISP_ACCESS_REPORTING_PAGE = 'CA_DISP_ACCESS_REPORTING_PAGE',
  CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE = 'CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE',
  CA_DISP_ACCESS_ONLINE_DISPATCHING_FOR_BALANCING_GROUP = 'CA_DISP_ACCESS_ONLINE_DISPATCHING_FOR_BALANCING_GROUP',
  CA_DISP_ACCESS_H_PLUS_X_SI_PAGE = 'CA_DISP_ACCESS_H_PLUS_X_SI_PAGE',
  CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE = 'CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE'
}

type ReportingCaType = ReportingCA;

export enum ReportingCA {
  CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE = 'CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE'
}
